import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import TextInput from "components/Input/TextInput.js";
import FloatInput from "components/Input/FloatInput";
import {
  CustomSelect,
} from "components/Input/Index.js";
import uuid from "react-uuid";
import Button from "@mui/material/Button";
import { makeStyles, withStyles } from "@mui/styles";
import ImageList from "@mui/material/ImageList";
import moment from "moment";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import UserService from "services/UserService";
import EmbeddedEntitesTree from "components/MenuEntites/EmbeddedEntitesTree";
import CustomSwitch from "components/Input/CustomSwitch.js";
import { putPoint } from "services/ConfigServices";
import styled from "styled-components";
import { dico } from "variables/lists/dico";
import { campaigncharttext } from "variables/MBM/campaign";
import { chartsourceData, chartgranularityData, charttypefullData, charttypepointData } from "variables/MBM/lists/campaign";
import AutocompleteInputMeters from "components/Input/AutocompleteInputMeters.js";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      //width: "30ch",
    },
  },
  formControl: {
    margin: 8,
    width: "62ch",
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  treeVisible: {
    display: "block",
  },
  treeHidden: {
    display: "none",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "5ch",
    width: "60ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "5ch",
    width: "60ch",
  },
  padding: {
    padding: '0px',
  },
  demo2: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
  demo3: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
}));

const TreeLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  opacity: 1;
  font-family: "Source Sans Pro", sans-serif;
`;

function ChartDialog(props) {
  const { closeModal, charts, existingChartsData, currentchart, setCharts, points } = props;
  const [source, setSource] = useState(currentchart?.source || "");
  const [name, setName] = useState(currentchart?.name || "");
  const [type, setType] = useState(currentchart?.type || "");
  const [granularity, setGranularity] = useState(currentchart?.granularity || "");
  const [buttonDisabled, setButtonDisabled] = useState(true);
  const [selectedExistingChart, setSelectedExistingChart] = useState("");
  const [existingchart, setExistingchart] = useState("");
  const [selectedPoint, setSelectedPoint] = useState("");
  const [pointid, setPointid] = useState(currentchart?.pointid || "");
  const [apppointid, setApppointid] = useState(currentchart?.apppointid || "");


  const [definitiondata, setDefinitiondata] = useState([]);
  const [selectedDefinition, setSelectedDefinition] = useState("");
  const [definition, setDefinition] = useState(currentchart?.definition || "");

  const handleSourceChange = (event) => { setSource(event.target.value); };
  const handleNameChange = (event) => { setName(event.target.value); };
  const handleTypeChange = (event) => { setType(event.target.value); };
  const handleGranularityChange = (event) => { setGranularity(event.target.value); };
  const handleExistingChartChange = (newValue) => {
    setExistingchart(newValue.id);
    setSelectedExistingChart(newValue);
  };
  const handlePointChange = (newValue) => {
    setApppointid(newValue.id); //use of id and not pointid to avoid sync issues, will be take into account at chart generation
    setSelectedPoint(newValue);
  };
  const handleDefinitionChange = (newValue) => {
    setDefinition(newValue.id);
    setSelectedDefinition(newValue);
  };

  useEffect(() => {
    let tmpdefinitiondata = dico.filter((item) =>
      points.find((x) => x.definition == item.id)
    );
    setDefinitiondata(tmpdefinitiondata);
  }, [points]);


  const classes = useStyles();

  const selectedPointFunc = () => {
    let selected = {};
    if (selectedPoint !== undefined) {
      selected = selectedPoint;
    }
    return selected;
  };
  const selectedDefinitionFunc = () => {
    let selected = {};
    if (selectedDefinition !== undefined) {
      selected = selectedDefinition;
    }
    return selected;
  };

  const selectedChart = () => {
    let selected = {};
    if (selectedExistingChart !== undefined) {
      selected = selectedExistingChart;
    }
    return selected;
  };


  const handleSubmit = (event) => {
    if (currentchart?.id) {
      let chartstmp = [...charts];
      let updatedchart = chartstmp.find((x) => x.id === currentchart.id);
      updatedchart.name = name;
      updatedchart.type = type;
      updatedchart.granularity = granularity;
      setCharts(chartstmp);
    }
    else {
      let newchart = {};
      newchart.id = uuid();
      newchart.source = source;
      if (source === 'existing')
        newchart.existingchart = existingchart;
      else if (source === 'point') {
        newchart.apppointid = apppointid;
        newchart.name = name;
        newchart.type = type;
        newchart.granularity = granularity;
      }
      else if (source === 'definition') {
        newchart.definition = definition;
        newchart.name = name;
        newchart.type = type;
        newchart.granularity = granularity;
      }
      let chartstmp = [...charts];
      newchart.position = chartstmp.length + 1;
      chartstmp.push(newchart);
      setCharts(chartstmp);
    }
    closeModal();
  };

  useEffect(() => {
    if (!source || (source !== 'existing' && (!name || !type || !granularity)) || (source === 'existing' && !existingchart))
      setButtonDisabled(true);
    else
      setButtonDisabled(false);
  }, [name, source, type, granularity, existingchart]);

  return (
    <>

      <form className={classes.root}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12} lg={12}>

            <div>
              <CustomSelect
                inputTitle={campaigncharttext.source}
                selectValue={source}
                handleSelectValueChange={handleSourceChange}
                data={chartsourceData}
                disabled={currentchart?.id}
              />
            </div>
            {(source && source === 'existing') &&
              <div>
                <AutocompleteInputMeters
                  specialWidth={"97%"}
                  inputMargin={"1rem 0rem 0rem"}
                  inputTitle={campaigncharttext.existingchart}
                  selected={selectedChart()}
                  list={existingChartsData}
                  handleChange={(_, newValue) =>
                    handleExistingChartChange(newValue)
                  }
                />
              </div>
            }
            {(source && source !== 'existing') &&
              <>
                {(source === 'point') ?
                  currentchart?.id ?
                    <div>
                      <TextInput
                        inputTitle={campaigncharttext.point}
                        textInput={pointid ? points.find((x) => x.pointid === pointid)?.name : points.find((x) => x.id === apppointid)?.name}
                        disabled
                      />
                    </div>
                    :
                    <div>
                      <AutocompleteInputMeters
                        disabled={currentchart?.id}
                        specialWidth={"97%"}
                        inputMargin={"1rem 0rem 0rem"}
                        inputTitle={campaigncharttext.point}
                        selected={selectedPointFunc()}
                        list={points}
                        handleChange={(_, newValue) =>
                          handlePointChange(newValue)
                        }
                      />
                    </div> : <></>
                }
                {(source === 'definition') ?
                  currentchart?.id ?
                    <div>
                      <TextInput
                        inputTitle={campaigncharttext.definition}
                        textInput={dico.find((x) => x.id == definition).name}
                        disabled
                      />
                    </div>
                    :
                    <div>
                      <AutocompleteInputMeters
                        disabled={currentchart?.id}
                        specialWidth={"97%"}
                        inputMargin={"1rem 0rem 0rem"}
                        inputTitle={campaigncharttext.definition}
                        selected={selectedDefinitionFunc()}
                        list={definitiondata}
                        handleChange={(_, newValue) =>
                          handleDefinitionChange(newValue)
                        }
                      />
                    </div> : <></>
                }
                <div>
                  <TextInput
                    inputTitle={campaigncharttext.name}
                    textInput={name}
                    handleTextInputChange={handleNameChange}
                  />
                </div>
                <div>
                  <CustomSelect
                    inputTitle={campaigncharttext.type}
                    selectValue={type}
                    handleSelectValueChange={handleTypeChange}
                    data={(source && source === 'point') ? charttypepointData : charttypefullData}
                  />
                </div>

                {
                  (type && type !== 'tab' && type !== 'pie') &&
                  <div>
                    <CustomSelect
                      inputTitle={campaigncharttext.granularity}
                      selectValue={granularity}
                      handleSelectValueChange={handleGranularityChange}
                      data={chartgranularityData}
                    />
                  </div>
                }
              </>
            }
          </GridItem>
        </GridContainer>
        <Button
          disabled={buttonDisabled}
          className={
            buttonDisabled
              ? classes.submitButtonDisabled
              : classes.submitButton
          }
          onClick={() => {
            handleSubmit();
          }}
        >
          Enregistrer
        </Button>
      </form>

    </>
  );
}

export default ChartDialog;
